// "Plunder" logo: skull with crossed cutlass + coin behind, set above the wordmark.
// Uses the painted PNG from public/art/ui/plunder_mark.png; SVG fallback below
// is preserved for any environment that fails to load the PNG.
import { uiImgUrl } from './art-png';
export function renderLogoMark(size = 96) {
    return `<img class="plunder-logo plunder-logo--png" src="${uiImgUrl('plunder_mark')}" width="${size}" height="${size}" alt="Plunder" />`;
}
export function renderLogoMarkSvg(size = 96) {
    return `<svg class="plunder-logo" viewBox="0 0 120 120" width="${size}" height="${size}" aria-hidden="true">
    <defs>
      <radialGradient id="lg-coin" cx="50%" cy="35%">
        <stop offset="0%" stop-color="#f8e88a"/>
        <stop offset="60%" stop-color="#c69b3c"/>
        <stop offset="100%" stop-color="#7a5018"/>
      </radialGradient>
      <linearGradient id="lg-blade" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stop-color="#dde0e8"/>
        <stop offset="50%" stop-color="#8a8e98"/>
        <stop offset="100%" stop-color="#444a55"/>
      </linearGradient>
    </defs>

    <!-- Coin behind everything -->
    <circle cx="60" cy="60" r="46" fill="url(#lg-coin)" stroke="#3a2412" stroke-width="2"/>
    <circle cx="60" cy="60" r="40" fill="none" stroke="#3a2412" stroke-width="0.8" stroke-dasharray="2 3" opacity="0.5"/>

    <!-- Crossed cutlasses -->
    <g transform="rotate(45 60 60)">
      <rect x="58" y="14" width="4" height="64" fill="url(#lg-blade)" stroke="#1a1a20" stroke-width="0.6"/>
      <path d="M58 78 L62 78 L62 88 Q60 92 58 88 Z" fill="#3a2412"/>
      <path d="M48 76 L72 76 L72 80 L48 80 Z" fill="#c69b3c" stroke="#3a2412" stroke-width="0.6"/>
    </g>
    <g transform="rotate(-45 60 60)">
      <rect x="58" y="14" width="4" height="64" fill="url(#lg-blade)" stroke="#1a1a20" stroke-width="0.6"/>
      <path d="M58 78 L62 78 L62 88 Q60 92 58 88 Z" fill="#3a2412"/>
      <path d="M48 76 L72 76 L72 80 L48 80 Z" fill="#c69b3c" stroke="#3a2412" stroke-width="0.6"/>
    </g>

    <!-- Skull on top -->
    <g>
      <ellipse cx="60" cy="58" rx="22" ry="20" fill="#f4e8d4" stroke="#1a1208" stroke-width="1.5"/>
      <ellipse cx="51" cy="58" rx="6" ry="7" fill="#1a1208"/>
      <ellipse cx="69" cy="58" rx="6" ry="7" fill="#1a1208"/>
      <circle cx="51" cy="58" r="1.5" fill="#f0c75a"/>
      <circle cx="69" cy="58" r="1.5" fill="#f0c75a"/>
      <path d="M56 70 L58 74 L60 70 L62 74 L64 70" stroke="#1a1208" stroke-width="1.5" fill="none"/>
      <path d="M55 67 Q60 64 65 67" stroke="#1a1208" stroke-width="1" fill="none"/>
      <path d="M54 76 L66 76 L64 80 L56 80 Z" fill="#f4e8d4" stroke="#1a1208" stroke-width="1"/>
      <line x1="58" y1="76" x2="58" y2="80" stroke="#1a1208" stroke-width="0.6"/>
      <line x1="62" y1="76" x2="62" y2="80" stroke="#1a1208" stroke-width="0.6"/>
    </g>
  </svg>`;
}
export function renderWordmark() {
    return `<div class="wordmark-block">
    ${renderLogoMark(72)}
    <h1 class="wordmark">Plunder</h1>
  </div>`;
}
